import { FormikInput } from "@faire/deprecated-retailer-visitor-shared/components/Form/FormikInput";
import { FormikTextArea } from "@faire/deprecated-retailer-visitor-shared/components/Form/FormikTextArea";
import { OptionalFieldLabel } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/fields/OptionalFieldLabel";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useDelayedCallback } from "@faire/web/ui/hooks/useDelayedCallback";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useRef } from "react";

type IFormikInputProps = React.ComponentProps<typeof FormikInput>;
type ITrackChangeProps = Pick<IFormikInputProps, "trackChange">;

export const WebsiteUrlField: React.FC<
  ITrackChangeProps & { isOptional?: boolean }
> = ({ trackChange, isOptional }) => {
  return (
    <FormikInput
      name="website_url"
      data-test-id="website-input"
      label={
        <>
          <StrictLocalMsg
            id="hpuqYr"
            defaultMessage="Website"
            description={{
              text: "Label for the website input field",
            }}
          />
          {isOptional ? <OptionalFieldLabel /> : null}
        </>
      }
      trackChange={trackChange}
    />
  );
};

export const PostalCodeField: React.FC<
  ITrackChangeProps & { isUSA?: boolean; isOptional?: boolean }
> = ({ trackChange, isUSA, isOptional }) => {
  return (
    <FormikInput
      name="postal_code"
      data-test-id="postal-code-input"
      label={
        <>
          {isUSA ? (
            <StrictLocalMsg
              id="kfSySF"
              defaultMessage="Zip code"
              description={{
                text: "Label for the zip code input field",
              }}
            />
          ) : (
            <StrictLocalMsg
              id="eGex2H"
              defaultMessage="Postal code"
              description={{
                text: "Label for the postal code input field",
              }}
            />
          )}
          {isOptional ? <OptionalFieldLabel /> : null}
        </>
      }
      trackChange={trackChange}
    />
  );
};

export const OtherStoreDescriptionField: React.FC<ITrackChangeProps> = ({
  trackChange,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const ref = useRef<HTMLTextAreaElement>(null);
  const focusInputField = useDelayedCallback(() => {
    ref.current?.focus({ preventScroll: true });
  });

  React.useEffect(() => {
    focusInputField(300);
  }, [focusInputField]);

  return (
    <FormikTextArea
      ref={ref}
      name="style_quiz.other_store_type"
      trackChange={trackChange}
      label={strictLocalize({
        id: "k/zT0x",
        defaultMessage: "Please describe your store",
        description: {
          text: "Other store text area label",
          img: "https://cdn.faire.com/fastly/65b87f0bd54b919c22d0c421eecebec35a136d215c06e9c279a50e20a1b315dc.png",
        },
      })}
      data-test-id="other-text-area"
      maxLength={250}
      rows={4}
    />
  );
};
